import { register, CloudObject, defineProperty, Direction, defineRelation } from 'olympe';

export const Languages = {
    EN: 'en',
    DE: 'de',
    FR: 'fr',
    IT: 'it',
    ZH: 'zh',
    ES: 'es',
    PT: 'pt',
    VI: 'vi',
    TR: 'tr'
};

/**
 * @param {string} language
 * @param {TranslatedString} item
 * @return {?string}
 */
export const getTranslatedString = (language, item) => {
    switch (language) {
        case Languages.EN: return item.get(TranslatedString.enProp);
        case Languages.DE: return item.get(TranslatedString.deProp);
        case Languages.FR: return item.get(TranslatedString.frProp);
        case Languages.IT: return item.get(TranslatedString.itProp);
        case Languages.ZH: return item.get(TranslatedString.zhProp);
        case Languages.ES: return item.get(TranslatedString.esProp);
        case Languages.PT: return item.get(TranslatedString.ptProp);
        case Languages.VI: return item.get(TranslatedString.viProp);
        case Languages.TR: return item.get(TranslatedString.trProp);
        default: return item.get(TranslatedString.enProp);
    }
}

/**
 * @extends {CloudObject}
 */
export default class TranslatedString extends CloudObject { /* empty */ }

// Hardcoded tags
register('018834174947cd16e04e', TranslatedString);
TranslatedString.enProp = defineProperty('01883417c5f9ae9a75e9');
TranslatedString.deProp = defineProperty('01883417d2e984129eaa');
TranslatedString.frProp = defineProperty('01883417e68f9b878718');
TranslatedString.itProp = defineProperty('018a8dde65f910c2a7e8');
TranslatedString.zhProp = defineProperty('018a8ddf2da6c8f1276b');
TranslatedString.esProp = defineProperty('018a8ddf430060314a6a');
TranslatedString.ptProp = defineProperty('018a8ddf6c7aeb9f6b96');
TranslatedString.viProp = defineProperty('018a8ddf9644f1255b9e');
TranslatedString.trProp = defineProperty('018a8ddfa5e50813eff3');
TranslatedString.inverse_evaluationtranslatedNameRel = defineRelation('018a97b6d9ef87e0cb2f', Direction.ORIGIN);
TranslatedString.inverse_evaluationtranslatedDescriptionRel = defineRelation('018a97b6f6aea975788b', Direction.ORIGIN);
TranslatedString.inverse_inspectionEntitytranslatedNameRel = defineRelation('018992356388c601d2f4', Direction.ORIGIN);
TranslatedString.inverse_inspectionEntitytranslatedDescriptionRel = defineRelation('01899235976073b73281', Direction.ORIGIN);
